






















































































































































































import { CreateGroupLicenseDTO } from '@/jbi-shared/dto/jaas-groups.dtos';
import {
  CourseLicensePreviewObject,
  CourseLicenseTemplateResponse
} from '@/jbi-shared/dto/jtms.dtos';
import { JAAS_APP } from '@/jbi-shared/types/jaas-app.types';
import { SortOrder } from '@/jbi-shared/types/search.types';
import { pluckNewValue } from '@/jbi-shared/util/pluck.rx-operator';
import BaseSwitch from '@/jbi-shared/vue-components/BaseSwitch.vue';
import { GroupDetail } from '@/store/modules/admin/types/admin.types';
import { GetGroupsProductResponsePayload } from '@/store/modules/admin/types/group-product.types';
import {
  CourseLicenseTemplateQueryParams,
  PaginatedCourseLicenseTemplate
} from '@/store/modules/jtms/course-license-template/course-license-template.types';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import Treeselect from '@riophae/vue-treeselect';
import dayjs from 'dayjs';
import { omit } from 'lodash';
import { IPaginationOptions, Pagination } from 'nestjs-typeorm-paginate';
import { filter, pluck } from 'rxjs/operators';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import LicenseExceedsCourseSizeConfirmationModal from './comfirmation-modals/LicenseExceedsCourseSizeConfirmationModal.vue';

@Component({
  components: {
    BaseSwitch,
    ValidationObserver,
    ValidationProvider,
    Treeselect,
    LicenseExceedsCourseSizeConfirmationModal
  }
})
export default class CourseLicenseForm extends Vue {
  @Prop(Number) id!: number;
  @Prop(String) name!: string;
  @Prop(String) startAt!: string;
  @Prop(String) endAt!: string;
  @Prop(Number) seats!: number;
  @Prop(Number) courseSize!: number;
  @Prop(Number) existingParticipants!: number;
  @Prop(Number) groupMemberCount!: number;
  @Prop(Number) groupId!: number;
  @Prop(Number) groupProductId!: number;
  @Prop(Boolean) isActive!: boolean;
  @Prop(String) existingLicenseName!: string;

  @PropSync('template', { type: Object })
  syncedTemplate!: CourseLicenseTemplateResponse;

  isSubmitButtonDisabled: boolean = true;
  switchSelection: boolean = false;

  form: Partial<CreateGroupLicenseDTO> & {
    dates: Date[];
    groupId: number | string;
    productId: number;
    notify: boolean;
  } = {
    name: this.name || '',
    seats: this.courseSize,
    groupId: this.groupId,
    productId: this.groupProductId,
    dates: [],
    notify: false
  };

  localStartAt: string = '';
  localEndAt: string = '';

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState
        .generateCourseLicensePreviewFromTemplate
  )
  generateCourseLicensePreviewFromTemplateApiState!: ApiState;

  @Action('course/setShouldCreateWithLicense')
  setShouldCreateWithLicense!: (payload: boolean) => void;

  @State(
    (state: RootState) =>
      state.course.courseLicenseState.shouldCreateWithLicense
  )
  shouldCreateWithLicense!: boolean;

  @Action('admin/getGroupProducts')
  getGroupProducts!: (
    options: IPaginationOptions
  ) => Promise<GetGroupsProductResponsePayload>;

  @Action('courseLicenseTemplate/getPaginatedCourseLicenseTemplate')
  getPaginatedCourseLicenseTemplate!: (
    payload: CourseLicenseTemplateQueryParams
  ) => Promise<PaginatedCourseLicenseTemplate>;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.paginatedCourseLicenseTemplates
  )
  courseLicenseTemplates!: Pagination<CourseLicenseTemplateResponse>;

  @State((state: RootState) => state.courseLicenseTemplate.courseLicensePreview)
  courseLicensePreview!: CourseLicensePreviewObject;

  @State((state: RootState) => state.admin.groupDetail)
  groupDetail!: GroupDetail;

  get templateOptions() {
    if (this.courseLicenseTemplates) {
      return this.courseLicenseTemplates.items;
    }

    return [];
  }

  get shouldDisableInputFields() {
    return this.generateCourseLicensePreviewFromTemplateApiState.loading;
  }

  get hasExistingLicense() {
    return !!this.groupDetail.license;
  }

  get applications() {
    return [{ id: JAAS_APP.sumari, name: 'SUMARI' }];
  }

  get groupProductsOptions() {
    return (this.$store.state as RootState).admin.groupProducts?.items;
  }

  get groups() {
    return (this.$store.state as RootState).admin.groups;
  }

  get minSeats() {
    return this.existingParticipants;
  }

  get submitLoading() {
    return (
      (this.$store?.state as RootState).admin.apiState.createGroupLicense
        .loading ||
      (this.$store?.state as RootState).admin.apiState.updateGroupLicense
        .loading
    );
  }

  get isLoading() {
    return (
      (this.$store?.state as RootState).admin.apiState.getGroupStats.loading ||
      (this.$store?.state as RootState).admin.apiState.getGroupProducts.loading
    );
  }

  get isEditing() {
    // Editing would resolve as false if ID is 0. Unlikely situation but
    // catering for it anyway
    return Boolean(this.id);
  }

  // Only allow numeral inputs
  checkDigit = (event: KeyboardEvent) => {
    if (event.key.length === 1 && isNaN(Number(event.key))) {
      event.preventDefault();
    }
  };

  async handleDatePickerToggle() {
    await this.$nextTick();
    const scroll = () =>
      ((this.$refs?.datepicker as Vue)?.$refs
        ?.dropdown as Vue)?.$el?.scrollIntoView();
    scroll();
  }

  handleSubmit() {
    let form = omit(this.form, 'dates');
    if (this.isEditing) {
      form = omit(form, 'groupId', 'productId');
    }
    this.$emit('submit', form);
  }

  assignStartEndDatesFromPropsToLocalVariables() {
    if (this.startAt && this.endAt) {
      this.localStartAt = this.startAt;
      this.localEndAt = this.endAt;
    }
  }

  assignStartEndDatesToDatesArray() {
    if (this.localStartAt && this.localEndAt) {
      this.form.dates = [
        dayjs(this.localStartAt).toDate(),
        dayjs(this.localEndAt).toDate()
      ];
    } else {
      this.form.dates = [];
    }
  }

  resetFormValues() {
    if (!this.shouldCreateWithLicense) {
      // Reset form values
      this.form.name = '';
      this.form.startAt = '';
      this.form.endAt = '';
      this.form.seats = this.courseSize;
      this.form.dates = [];
      this.form.productId = this.groupProductId;
      this.form.notify = false;
    }
  }

  mounted() {
    this.setShouldCreateWithLicense(false);
    this.getPaginatedCourseLicenseTemplate({
      page: 1,
      limit: 100,
      sortOrder: SortOrder.ASC
    });

    this.getGroupProducts({
      page: 1,
      limit: Math.pow(10, 3)
    });

    this.$watchAsObservable('form', { deep: true })
      .pipe(pluckNewValue(), filter(Boolean), pluck('dates'), filter(Boolean))
      .subscribe((dates) => {
        const [startAt, endAt] = dates as Date[];
        this.form.startAt = dayjs(startAt).format('YYYY-MM-DD');
        this.form.endAt = dayjs(endAt).format('YYYY-MM-DD');
      });

    this.assignStartEndDatesFromPropsToLocalVariables();
    this.assignStartEndDatesToDatesArray();
  }

  @Watch('shouldCreateWithLicense')
  onCreateWithLicenseToggled() {
    this.resetFormValues();
    this.assignStartEndDatesFromPropsToLocalVariables();
    this.assignStartEndDatesToDatesArray();
  }

  @Watch('shouldCreateWithLicense')
  @Watch('form.name')
  @Watch('form.dates')
  @Watch('form.seats')
  @Watch('minSeats')
  public watchFormValues() {
    const formValues = JSON.parse(JSON.stringify(this.form));
    this.isSubmitButtonDisabled = !(
      this.form.name &&
      this.form.startAt &&
      this.form.endAt &&
      this.form.seats &&
      this.form.dates.length &&
      this.minSeats !== undefined &&
      this.form.seats >= this.minSeats &&
      formValues.productId !== undefined
    );

    const formHasError: boolean =
      this.isSubmitButtonDisabled && this.shouldCreateWithLicense;
    this.$emit('form-has-error', formHasError, this.form);
  }

  @Watch('form.seats')
  onSeatValueUpdated() {
    this.$emit('seat-value', this.form.seats);
  }

  @Watch('switchSelection')
  onSwitchSelectionChanged() {
    this.setShouldCreateWithLicense(this.switchSelection);
  }

  @Watch('generateCourseLicensePreviewFromTemplateApiState', { deep: true })
  onPreviewGenerated(state: ApiState) {
    if (state.success && this.courseLicensePreview) {
      this.form.name = this.courseLicensePreview.processedName;
      this.form.productId = this.courseLicensePreview.groupProductId;

      this.localStartAt = this.courseLicensePreview.startDate;
      this.localEndAt = this.courseLicensePreview.endDate;
      this.assignStartEndDatesToDatesArray();
      // this.watchFormValues();
    }
  }
}
